import { useMemo } from "react";

const useIsTouchDevice = (): boolean => {
  return useMemo(() => {
    if (
      (window.PointerEvent && navigator.maxTouchPoints > 0) ||
      "ontouchstart" in window
    ) {
      return true;
    }

    return false;
  }, []);
};

export { useIsTouchDevice };
